import { store } from 'store/store';

import { AppStateProvider } from './app-state-provider';

AppStateProvider.setup(store);
